import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section aria-labelledby="category-title" className="px-4 py-12 md:px-6 md:py-16">
      <div className="mb-7 text-center">
        <p className="mb-2 text-xs font-medium tracking-[0.25em] text-primary-600">CATEGORIES</p>
        <h2 id="category-title" className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          挑个栏目，按口味吃瓜
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
          六个常驻栏目覆盖娱乐热点的主要方向，点进去就能只看你感兴趣的那一类，不用在信息流里反复筛选。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((cat, index) => {
          const isAccent = index === 0;
          return (
            <Link
              key={cat.slug}
              to={`/news?cat=${cat.slug}`}
              className={`group flex items-start gap-4 rounded-lg border p-5 transition-colors ${
                isAccent
                  ? "border-accent-300 bg-accent-100/70 hover:border-accent-400"
                  : "border-background-200 bg-background-50 hover:border-primary-300"
              }`}
            >
              <span
                className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-lg ${
                  isAccent ? "bg-accent-500 text-foreground-950" : "bg-primary-100 text-primary-700"
                }`}
              >
                <i className={`${cat.icon} text-xl`} aria-hidden="true" />
              </span>
              <span className="min-w-0 flex-1">
                <span className="flex items-center gap-1.5 font-heading text-base font-bold text-foreground-950">
                  {cat.name}
                  <i
                    className="ri-arrow-right-up-line text-sm text-foreground-400 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                    aria-hidden="true"
                  />
                </span>
                <span className="mt-1.5 block text-sm leading-relaxed text-foreground-600">
                  {cat.desc}
                </span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}